import React, { useState, useEffect } from "react";
import { Box, Typography, Grid, Link as LinkMui } from "@mui/material";
import styles from "./header.module.css";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import axios from "axios";
import {fontType} from "../../constants/font";
import {courses} from "../../data/courses";
import {courseGroups} from "../../data/courseGroups";
import CourseBox from "../courses/CourseBox";

const Products = ({ setContactForm, windowWidth }) => {
  const [fetchedData, setFetchedData] = useState([]);

  const [ref, inView] = useInView({
    triggerOnce: true, // Only trigger the animation once when scrolled into view
  });
  const [products, inViewProducts] = useInView({
    triggerOnce: true, // Only trigger the animation once when scrolled into view
  });

  // FETCHING DATA
  useEffect(() => {
    const fetchCourseData = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}trainings?filter=with_valid_terms`);
        const data = response.data;
        setFetchedData(data.data);
      } catch (error) {
        console.log(error);
      }
    };

    fetchCourseData();
  }, []);

  return (
    <Box
      sx={{
        backgroundColor: "#d8d8d8",
        display: "flex",
        justifyContent: "center",
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          maxWidth: "1440px",
          width: "100%",
          position: "relative",
        }}
      >
        <motion.div
          ref={ref}
          initial={{ opacity: 0, y: 50 }}
          animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 50 }}
          transition={{ duration: 0.7 }}
        >
          <Box
            sx={{
              marginTop: "37px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 2,
              position: "relative",
            }}
          >
            <Typography
              sx={{
                textAlign: "center",
                fontFamily: fontType.regular,
                fontSize: 38,
                color: "#1d1a56",
                marginBottom: "15px",
              }}
            >
                Najpredávanejšie školenia{" "}
            </Typography>

            <Typography
              sx={{
                textAlign: "center",
                fontFamily: fontType.regular,
                fontSize: 22,
                lineHeight: "28px",
                color: "#1d1a56",
                paddingLeft: "20px",
                paddingRight: "20px",
              }}
            >
              Ponúkame školenia formou online výuky. <br />
              Možnosť aj onsite školení na základe dohody.
            </Typography>
            <LinkMui
              onClick={() => setContactForm(true)}
              style={{
                textAlign: "center",
                fontFamily: fontType.semiBold,
                fontSize: 22,
                lineHeight: "28px",
                color: "#1d1a56",
                decoration: "underline",
                textDecorationColor: "#1d1a56",
                cursor: "pointer",
              }}
            >
              kontaktovať
            </LinkMui>
          </Box>
        </motion.div>
        <motion.div
          ref={products}
          initial={{ opacity: 0, y: 50 }}
          animate={inViewProducts ? { opacity: 1, y: 0 } : { opacity: 0, y: 50 }}
          transition={{ duration: 0.7 }}
        >
          <Grid
            container
            sx={{
              paddingLeft: windowWidth < 2700 ? "9vw" : "0",
              paddingRight: windowWidth < 2700 ? "9vw" : "0",
              marginTop: "40px",
              position: "relative",
              zIndex: 2,
              display: "flex",
              justifyContent: "center",
              gap: "50px",
              marginBottom: "80px",
            }}
          >
            {courseGroups.top?.map(courseCode => {
                const course = courses.find((course) => course.code === courseCode);
                const courseData = fetchedData.find((courseData) => courseData.code === course.code);

                return (
                    <CourseBox
                        key={`${courseCode}-${courseData?.id}`}
                        course={course}
                        courseData={courseData}
                        group="top"
                    />
                )
            })}
          </Grid>
        </motion.div>
        <img
          className={styles.element}
          style={{
            position: "absolute",
            top: 100,
            zIndex: 1,
          }}
          src={require("../../assets/elements2.png")}
          alt="academy_logo"
        />
      </Box>
    </Box>
  );
};

export default Products;
